{
	"titlePage": "Conferencia de eventos",
	"toThe": "en",
	"infoPage": "Al procesar un evento, se envía la información de facturación a cuentas por pagar, cuentas por cobrar, flujo de caja y DRE.",
	"viewDataConference": "Ver conferencia",
	"viewDataConferenceDetails": "Detalles de la conferencia",
	"dataActions": {
		"viewDetails": "Ver detalles",
		"eventProcess": "Procesar evento"
	},
	"tableColumns": {
		"date": "Fecha",
		"eventName": "Nombre del evento",
		"totalIncome": "Ingresos brutos",
		"status": "Estatus",
		"actions": "Acciones",
		"dateAndTimeProccess": "Fecha y hora del procesamiento",
		"checkedBy": "Procesado por"
	},
	"textPerStatus": {
		"loading": "Por favor, espere, estamos procesando las conferencias",
		"success": "Todas las conferencias se han procesado correctamente",
		"conclude": "Completado"
	},
	"titleProcess": {
		"processing": "Procesando",
		"processed": "Procesado",
		"processConferences": "Procesar conferencias"
	},
	"filter": {
		"searchName": {
			"title": "Buscar eventos",
			"label": "Ingrese el nombre del evento"
		},
		"searchDate": {
			"title": "Período"
		},
		"searchStatus": {
			"title": "Mostrar estatus"
		}
	},
	"buttonProcessMultiple": "Procesar eventos"
}
